import 'react-native-gesture-handler';
import { useEffect, useState } from 'react';
import { ActivityIndicator, Image, TouchableOpacity, View } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { MaterialIcons } from '@expo/vector-icons';
import { NavigationContainer, DefaultTheme } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { NativeWindStyleSheet } from 'nativewind';
import HomeScreen from './screens/HomeScreen';
import AddTransactionScreen from './screens/AddTransactionScreen';
import AnalyticsScreen from './screens/AnalyticsScreen';
import PlanningScreen from './screens/PlanningScreen';
import AuthScreen from './screens/AuthScreen';
import { fetchMe, loadStoredToken, logout } from './lib/api';

NativeWindStyleSheet.setOutput({
  default: 'native',
});

const Stack = createNativeStackNavigator();

const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    background: '#f8fafc',
  },
};

export default function App() {
  const [booting, setBooting] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const boot = async () => {
      try {
        const token = await loadStoredToken();
        if (token) {
          const session = await fetchMe();
          setUser(session.user);
        }
      } catch (error) {
        await logout().catch(() => {});
      } finally {
        setBooting(false);
      }
    };
    boot();
  }, []);

  if (booting) {
    return (
      <View className="flex-1 items-center justify-center bg-slate-950">
        <Image source={require('./assets/logo.png')} className="h-24 w-24 rounded-3xl" resizeMode="contain" />
        <ActivityIndicator className="mt-5" color="#22d3ee" />
      </View>
    );
  }

  if (!user) return <AuthScreen onAuthenticated={setUser} />;

  return (
    <NavigationContainer theme={theme}>
      <Stack.Navigator
        screenOptions={{
          headerStyle: { backgroundColor: '#ffffff' },
          headerTintColor: '#0f172a',
          headerTitleStyle: { fontWeight: '800' },
          contentStyle: { backgroundColor: '#f8fafc' },
          headerRight: () => (
            <TouchableOpacity
              accessibilityLabel="Logout"
              className="h-10 w-10 items-center justify-center rounded-full bg-cyan-50"
              onPress={async () => {
                await logout();
                setUser(null);
              }}
            >
              <MaterialIcons name="logout" size={22} color="#0e7490" />
            </TouchableOpacity>
          ),
        }}
      >
        <Stack.Screen name="Home" component={HomeScreen} options={{ title: 'AurionXtrack' }} />
        <Stack.Screen name="AddTransaction" component={AddTransactionScreen} options={{ title: 'Record Transaction' }} />
        <Stack.Screen name="Analytics" component={AnalyticsScreen} options={{ title: 'Analysis' }} />
        <Stack.Screen name="Planning" component={PlanningScreen} options={{ title: 'Planning' }} />
        <Stack.Screen name="SavingsGoals" component={PlanningScreen} options={{ title: 'Savings Goals' }} initialParams={{ single: 'saving' }} />
        <Stack.Screen name="Expenses" component={PlanningScreen} options={{ title: 'Expenses' }} initialParams={{ single: 'expenses' }} />
        <Stack.Screen name="ExpensePlans" component={PlanningScreen} options={{ title: 'Expenses' }} initialParams={{ single: 'expenses' }} />
        <Stack.Screen name="Wishlist" component={PlanningScreen} options={{ title: 'Wishlist' }} initialParams={{ single: 'wishlist' }} />
        <Stack.Screen name="FundPartitions" component={PlanningScreen} options={{ title: 'Fund Partitions' }} initialParams={{ single: 'partition' }} />
        <Stack.Screen name="RecurringExpenses" component={PlanningScreen} options={{ title: 'Recurring Expenses' }} initialParams={{ single: 'recurring' }} />
        <Stack.Screen name="CutSuggestions" component={PlanningScreen} options={{ title: 'Cut Suggestions' }} initialParams={{ single: 'cut' }} />
      </Stack.Navigator>
      <StatusBar style="dark" />
    </NavigationContainer>
  );
}
